import {colors, sizes} from "patient-ping-remedy/packages/theme";
import styled from '@emotion/styled';
import Badge from "patient-ping-remedy/packages/badge";

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
  gap: ${sizes.small};
  flex: 1;
`;

export const FormBadge = styled(Badge)<{ editing: boolean }>`
  background-color: ${({ editing }) => editing ? colors.yellow4 : colors.green5};
  color: ${({ editing }) => editing ? colors.charcoal : colors.white};
  border-radius: ${sizes.small};
`;
